import Vue from 'vue';
import Vuex from 'vuex';
import loading from './module/loading';
import scene from './module/scene';
import frame from './module/frame';
import dealer from './module/dealer';
import intended from './module/intended';
import news from './module/news';
import certificate from './module/certificate';
import specPic from './module/specPic';
import specParameter from './module/spec.parameter';
import sales from './module/sales';
import user from './module/user';
import phoneCall from './module/phoneCall';
import busiIcsApp from './module/busiIcsApp';
import abTest from './module/abTest';
import callStatus from './module/callingState';
import redPacket from './module/redPacket';
// import specVideo from './module/specVideo';
import specDot from './module/specDot';
import priceList from './module/priceList';
import pageQuery from '../services/pageQuery.service';
import dealerApi from '../apis/dealer.api';
import queryParams from '../services/pageQuery.service';

import { Logger } from '../services/logger';
import { errorPage } from '../config/index';

Vue.use(Vuex);
let baseInfoPromise = null;
let functionDataPromise = null;
const pageData = window.pageFunc;
// vue 2.7 中 hasChanged 方法 判断存在问题， NaN === NaN  为false， 导致判断为没有改变
let dealerIdInitVal = parseInt(pageData.dealerId, 10);
dealerIdInitVal = isNaN(dealerIdInitVal) ? 0 : dealerIdInitVal;
const store = new Vuex.Store({
  state: {
    baseInfo: {
      isqirui: -1,
      dealerId: dealerIdInitVal,
      dealerInfoId: 0,
      dealerName: '',
      cityId: 0,
      isVrDealerModel: 0,
      address: '',
      mapLonBaidu: 0,
      mapLatBaidu: 0,
      source: pageData.source,
      fdRight: {
        dealerId: dealerIdInitVal,
        hasPublish: false,
        hasRights: false,
        sceneId: '',
        virtualSceneId: '',
      },
    },
    functionData: {
      videoNumInfo: {
        allNum: 0,
        gold: 0,
        people: 0,
        brand: 0,
        ruihu3x: 0,
        kupao: 0,
      },
      gameList: [],
      imInfo: {
        shareAdvisor: null,
        displayAdviser: null,
        isRandom: true,
      },
      shareInfo: null,
      promotions: null,
      activityList: null,
      sceneThumbnailList: [],
      welcomeAd: null,
      saleSetting: null,
      adviserSetting: null,
    },
    hasVideo: false,
    activitys: [],
    promotions: [],
    hideBottom: false,
    hasWXshow: false, // 判断报价单弹层是否弹出
    isSHowSmartGuide: false,
  },
  mutations: {
    setIsSHowSmartGuide(state, isShow) {
      state.isSHowSmartGuide = isShow;
    },
    setBaseInfo(state, baseInfo) {
      state.baseInfo = Object.assign(state.baseInfo, baseInfo);
      state.baseInfo.cityId = Number(pageQuery.cityId || state.baseInfo.cityId);
      state.baseInfo.cityId = isNaN(state.baseInfo.cityId)
        ? 0
        : state.baseInfo.cityId;
    },
    setHideBottom(state, hide) {
      state.hideBottom = hide;
    },
    setHasWXshow(state, data) {
      state.hasWXshow = data;
    },
    setActivitysAndPromotions(state, { promotions, activitys }) {
      state.activitys = activitys || [];
      state.promotions = promotions || [];
    },
    setFunctionData(state, data) {
      for (const key in data) {
        if (data[key]) {
          state.functionData[key] = data[key];
        }
      }
      state.baseInfo.isqirui = -1;
      if (state.dealer.dealerInfo && state.dealer.dealerInfo.Brands) {
        state.dealer.dealerInfo.Brands.indexOf('奇瑞') ? 1 : -1;
      }
      const videoNumInfo = state.functionData.videoNumInfo;
      if (state.baseInfo.isqirui === -1 && videoNumInfo) {
        state.functionData.videoNumInfo.allNum =
          videoNumInfo.allNum -
          videoNumInfo.people -
          videoNumInfo.ruihu3x -
          videoNumInfo.kupao;
      }
      if (
        data.activityList &&
        data.activityList.list &&
        data.activityList.list.length > 0
      ) {
        state.activitys = data.activityList.list || [];
      }

      if (data.promotions && data.promotions.list.length > 0) {
        state.promotions = data.promotions.list || [];
      }
    },
  },
  getters: {
    isSHowSmartGuide: (state) => state.isSHowSmartGuide,
    baseInfo: (state) => state.baseInfo,
    hasVideo: (state) =>
      state.functionData &&
      state.functionData.videoNumInfo &&
      state.functionData.videoNumInfo.allNum > 0,
    videoNum: (state) => state.functionData && state.functionData.videoNumInfo,
    hideBottom: (state) => state.hideBottom,
    activitys: (state) => state.activitys,
    promotions: (state) => state.promotions,
    dealerId: (state) => state.baseInfo.dealerId,
    functionData: (state) => state.functionData,
    hasIm: (state) => {
      return !!(
        state.functionData &&
        state.functionData.imInfo &&
        state.functionData.imInfo.displayAdviser &&
        state.functionData.imInfo.displayAdviser.linkUrl &&
        state.functionData.imInfo.displayAdviser.appChatScheme
      );
    },
  },
  actions: {
    getBaseInfo({ state, commit }) {
      const dealerId = state.baseInfo.dealerId;
      const source = state.baseInfo.source;
      const floor = queryParams.floor || 0;
      if (!baseInfoPromise) {
        baseInfoPromise = dealerApi
          .getPageInfo({
            dealerId,
            source,
            floor,
          })
          .then(function (result) {
            commit('setBaseInfo', result);
            if (result && result.dealerInfo) {
              commit('dealer/setDealerInfo', result.dealerInfo);
            }
            return Promise.resolve(result);
          })
          .catch(function (ex) {
            const logger = new Logger('baseInfo');
            logger.info('baseInfoError--' + JSON.stringify(ex));
            window.location.href = errorPage;
            return Promise.resolve({
              returncode: 1,
              message: ex.message,
              result: ex,
            });
          });
      }
      return baseInfoPromise;
    },
    getFunctionData({ state, commit, dispatch }) {
      if (functionDataPromise) {
        return functionDataPromise;
      }
      functionDataPromise = dispatch('getBaseInfo')
        .then(function () {
          const fdRight = state.baseInfo.fdRight;
          const is4d =
            fdRight &&
            fdRight.hasPublish &&
            fdRight.hasRights &&
            fdRight.sceneId
              ? 1
              : 0;
          return Promise.all([
            dealerApi.getFunctionData({
              dealerId: state.baseInfo.dealerId,
              salesId: queryParams.salesId,
              is4d: is4d,
            }),
            dealerApi
              .getImInfo({
                dealerId: state.baseInfo.dealerId,
                bsnsId: 16000,
                userId: queryParams.userId,
              })
              .catch(() => {
                return null;
              }),
          ]).then(([result, imInfo]) => {
            result.imInfo = imInfo;
            return result;
          });
        })
        .then(function (result) {
          if (result) {
            commit('setFunctionData', result);
            if (result.sceneThumbnailList) {
              commit('scene/setSceneList', result.sceneThumbnailList);
            }
            if (result.imInfo && result.imInfo.shareAdvisor) {
              const shareAdvisor = result.imInfo.shareAdvisor;
              commit('sales/setSalesInfo', {
                salesId: shareAdvisor.salesId || 0,
              });
            }
            if (result.saleSetting) {
              commit('sales/setVrSaleSetting', result.saleSetting);
            }
          }
          return result;
        });
      return functionDataPromise;
    },
  },
  modules: {
    loading,
    scene,
    frame,
    dealer,
    intended,
    news,
    certificate,
    specPic,
    specParameter,
    sales,
    user,
    phoneCall,
    busiIcsApp,
    abTest,
    callStatus,
    redPacket,
    // specVideo,
    specDot,
    priceList,
  },
});
export default store;
